export default __webpack_public_path__ + "static/media/movilbeam.f1a8bafe.png";